import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { TestimonialsInitial } from './components/TestimonialsInitial';
import { PainPoints } from './components/PainPoints';
import { ProductPresentation } from './components/ProductPresentation';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { PackElite } from './components/PackElite';
import { TestimonialsExtended } from './components/TestimonialsExtended';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '1904779843432668');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-background font-sans text-gray-900 selection:bg-primary/20 selection:text-primary" data-id="element-0">
      <HeroSection data-id="element-1" />
      <TestimonialsInitial data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductPresentation data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <PackElite data-id="element-8" />
      <TestimonialsExtended data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQ data-id="element-11" />
      <ComparisonTable data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}